// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QuoteSelectionHighlight__container-b18ea2 {
  --highlight-in-and-out-animation-duration: 0s;
  display: inline;
  font: var(--font-body-5);
}

.QuoteSelectionHighlight__wrapper-f60084 {
  position: relative;
  width: 100%;
  height: 100%;
  vertical-align: top;
  z-index: 0;
  display: inline;
}

.QuoteSelectionHighlight__text-highlighter-e3716d {
  position: absolute;
  z-index: 1;
  left: 0;
  top: -2px;
  width: 100%;
  height: 100%;
}

.QuoteSelectionHighlight__highlight-enter-fda2f2 {
  opacity: 0;
}

.QuoteSelectionHighlight__highlight-enter-active-c8eacc {
  opacity: 1;
  transition: opacity var(--highlight-in-and-out-animation-duration) linear;
}

.QuoteSelectionHighlight__highlight-exit-de380b {
  opacity: 1;
}

.QuoteSelectionHighlight__highlight-exit-active-c33d74 {
  opacity: 0;
  transition: opacity var(--highlight-in-and-out-animation-duration) linear;
}

.QuoteSelectionHighlight__highlight-exit-active-c33d74 .QuoteSelectionHighlight__highlight-e88bed {
  transform: scaleX(1.2) scaleY(0.9);
  transition: transform var(--highlight-in-and-out-animation-duration) linear;
}

.QuoteSelectionHighlight__content-b1bf25 {
  z-index: 2;
  position: relative;
  display: inline;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/components/QuoteSelectionHighlight/QuotedSelectionHighlight.styles.m.css"],"names":[],"mappings":"AAAA;EACE,6CAAA;EACA,eAAA;EACA,wBAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,UAAA;EACA,eAAA;AACF;;AAEA;EACE,kBAAA;EACA,UAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,UAAA;EACA,yEAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,UAAA;EACA,yEAAA;AACF;;AAEA;EACE,kCAAA;EACA,2EAAA;AACF;;AAEA;EACE,UAAA;EACA,kBAAA;EACA,eAAA;AACF","sourcesContent":[".container {\n  --highlight-in-and-out-animation-duration: 0s;\n  display: inline;\n  font: var(--font-body-5);\n}\n\n.wrapper {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  vertical-align: top;\n  z-index: 0;\n  display: inline;\n}\n\n.text-highlighter {\n  position: absolute;\n  z-index: 1;\n  left: 0;\n  top: -2px;\n  width: 100%;\n  height: 100%;\n}\n\n.highlight-enter {\n  opacity: 0;\n}\n\n.highlight-enter-active {\n  opacity: 1;\n  transition: opacity var(--highlight-in-and-out-animation-duration) linear;\n}\n\n.highlight-exit {\n  opacity: 1;\n}\n\n.highlight-exit-active {\n  opacity: 0;\n  transition: opacity var(--highlight-in-and-out-animation-duration) linear;\n}\n\n.highlight-exit-active .highlight {\n  transform: scaleX(1.2) scaleY(0.9);\n  transition: transform var(--highlight-in-and-out-animation-duration) linear;\n}\n\n.content {\n  z-index: 2;\n  position: relative;\n  display: inline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `QuoteSelectionHighlight__container-b18ea2`,
	"wrapper": `QuoteSelectionHighlight__wrapper-f60084`,
	"text-highlighter": `QuoteSelectionHighlight__text-highlighter-e3716d`,
	"textHighlighter": `QuoteSelectionHighlight__text-highlighter-e3716d`,
	"highlight-enter": `QuoteSelectionHighlight__highlight-enter-fda2f2`,
	"highlightEnter": `QuoteSelectionHighlight__highlight-enter-fda2f2`,
	"highlight-enter-active": `QuoteSelectionHighlight__highlight-enter-active-c8eacc`,
	"highlightEnterActive": `QuoteSelectionHighlight__highlight-enter-active-c8eacc`,
	"highlight-exit": `QuoteSelectionHighlight__highlight-exit-de380b`,
	"highlightExit": `QuoteSelectionHighlight__highlight-exit-de380b`,
	"highlight-exit-active": `QuoteSelectionHighlight__highlight-exit-active-c33d74`,
	"highlightExitActive": `QuoteSelectionHighlight__highlight-exit-active-c33d74`,
	"highlight": `QuoteSelectionHighlight__highlight-e88bed`,
	"content": `QuoteSelectionHighlight__content-b1bf25`
};
module.exports = ___CSS_LOADER_EXPORT___;
